export const FORM = `{
  id
  data
  partner_id
  status
  form_source
  ref_link
  lead_progress
  last_activity
  last_activity_time
  lifecycle_stage
  lastUpdatedBy
  createdAt
  updatedAt
  __typename
}`
